var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 596.85 223.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 12332.29,
    y1: 13889.86,
    x2: 12375.43,
    y2: 13889.86,
    gradientTransform: "rotate(-180 6446.76 7046.455)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6e6f70",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6e6f70",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6e6f70",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6e6f70",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e6f70",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -122.73,
    y1: 12679.95,
    x2: -62.2,
    y2: 12679.95,
    gradientTransform: "rotate(90 6465.09 6732.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1c4e74",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1c4e74",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#1c4e74",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1c4e74",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -122.73,
    y1: 12681.25,
    x2: -62.2,
    y2: 12681.25,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 12332.29,
    x2: 12375.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -122.73,
    y1: 12679.83,
    x2: -62.2,
    y2: 12679.83,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 423.26,
    y1: 185.41,
    x2: 500.5,
    y2: 185.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 423.26,
    y1: 194.15,
    x2: 500.5,
    y2: 194.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 12332.3,
    y1: 13907.5,
    x2: 12375.43,
    y2: 13907.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 13898.69,
    x2: 12375.43,
    y2: 13898.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 12332.29,
    y1: 13965.29,
    x2: 12392.82,
    y2: 13965.29,
    gradientTransform: "rotate(-180 6446.76 7046.455)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6e6f70",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6e6f70",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6e6f70",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6e6f70",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 12332.3,
    y1: 13947.83,
    x2: 12392.82,
    y2: 13947.83,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 12332.29,
    y1: 13947.91,
    x2: 12392.82,
    y2: 13947.91,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 12332.29,
    y1: 13947.82,
    x2: 12392.82,
    y2: 13947.82,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 12332.29,
    y1: 13963.82,
    x2: 12392.82,
    y2: 13963.82,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    y1: 13956.61,
    x2: 12392.82,
    y2: 13956.61,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 12332.29,
    y1: 13956.58,
    x2: 12392.82,
    y2: 13956.58,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 13357.82,
    y1: 12983.19,
    x2: 13381.67,
    y2: 12983.19,
    gradientTransform: "matrix(0 -1 -1 0 13406.43 13439.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c4e74",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c4e74",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 13357.83,
    y1: 13000.62,
    x2: 13381.68,
    y2: 13000.62,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    y1: 12991.91,
    x2: 13381.67,
    y2: 12991.91,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -122.73,
    y1: 12679.92,
    x2: -62.2,
    y2: 12679.92,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -122.73,
    y1: 12697.34,
    x2: -62.2,
    y2: 12697.34,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -122.73,
    y1: 12697.29,
    x2: -62.2,
    y2: 12697.29,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -122.73,
    y1: 12681.25,
    x2: -62.2,
    y2: 12681.25,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -122.73,
    y1: 12697.24,
    x2: -62.2,
    y2: 12697.24,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -122.73,
    y1: 12697.24,
    x2: -62.2,
    y2: 12697.24,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -122.73,
    y1: 12680.01,
    x2: -62.2,
    y2: 12680.01,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -122.73,
    y1: 12697.36,
    x2: -62.2,
    y2: 12697.36,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -122.73,
    y1: 12697.16,
    x2: -62.2,
    y2: 12697.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -122.73,
    y1: 12688.67,
    x2: -62.2,
    y2: 12688.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 12332.29,
    x2: 12375.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -122.73,
    y1: 12679.83,
    x2: -62.2,
    y2: 12679.83,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 12332.29,
    y1: 13907.5,
    x2: 12375.43,
    y2: 13907.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -122.73,
    y1: 12679.87,
    x2: -86.75,
    y2: 12679.87,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 12332.29,
    y1: 13898.69,
    x2: 12375.43,
    y2: 13898.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -122.73,
    y1: 12679.83,
    x2: -62.2,
    y2: 12679.83,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 12332.29,
    y1: 13947.67,
    x2: 12392.82,
    y2: 13947.67,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -122.73,
    y1: 12697.28,
    x2: -62.2,
    y2: 12697.28,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 12332.29,
    y1: 13947.71,
    x2: 12392.82,
    y2: 13947.71,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -122.73,
    y1: 12697.24,
    x2: -62.2,
    y2: 12697.24,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 12332.29,
    y1: 13947.79,
    x2: 12385.71,
    y2: 13947.79,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -122.73,
    y1: 12680.01,
    x2: -62.2,
    y2: 12680.01,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 12332.29,
    y1: 13947.76,
    x2: 12392.82,
    y2: 13947.76,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -122.73,
    y1: 12688.61,
    x2: -62.2,
    y2: 12688.61,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 14103.94,
    y1: 11864.73,
    x2: 14155.05,
    y2: 11864.73,
    gradientTransform: "scale(-1 1) rotate(-82.28 13.815 14357.389)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a5c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e6f70",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 14103.94,
    y1: 11899.97,
    x2: 14155.05,
    y2: 11899.97,
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 14103.94,
    y1: 11876.24,
    x2: 14155.03,
    y2: 11876.24,
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 14103.94,
    y1: 11911.37,
    x2: 14155.05,
    y2: 11911.37,
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 13356.8,
    y1: 1257.09,
    x2: 13380.8,
    y2: 1257.09,
    gradientTransform: "rotate(-90 6389.485 7050.055)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e6f70",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e6f70",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 13356.8,
    y1: 1239.3,
    x2: 13380.8,
    y2: 1239.3,
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    y1: 1248.2,
    x2: 13380.8,
    y2: 1248.2,
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 13356.8,
    y1: 1249.77,
    x2: 13380.8,
    y2: 1249.77,
    xlinkHref: "#linear-gradient-48"
  }), /*#__PURE__*/React.createElement("style", null, ".cls-2,.cls-53,.cls-54,.cls-56,.cls-57{stroke-width:0}.cls-2,.cls-57{mix-blend-mode:multiply}.cls-2{fill:url(#linear-gradient-2)}.cls-2,.cls-57{opacity:.56}.cls-53{fill:#59a7c4}.cls-54{fill:#959494}.cls-56{fill:#afafaf}.cls-57{fill:url(#linear-gradient)}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m500.71 203.04 17.12 14.03.02-11.83-2.25-2.2h-14.89z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M518.21 203.04h43.02v.03h-43.02z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M518.09 203.04h-.23l-.01 2.2.37.35-.01-2.52h-.12v-.03z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m515.6 203.04 2.25 2.2.01-2.2h-2.26z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-3)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "m515.6 203.04 2.25 2.2.01-2.2h-2.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-4)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M518.09 203.04h.12v.03h-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-5)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M518.09 203.04h.12v.03h-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      fill: "none"
    },
    d: "m517.98 147.55.16 37.86h43.08V145l-43.24.17v2.38z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m358.67 218.04 3.52 3.13V3.53l-3.52-1.34v215.85z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363559",
      strokeWidth: 0
    },
    d: "m499.37 5.22.04-.02-.08-.04-18.35 8.1v.01l18.31-8.09.08.04z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m500.71 203.04 17.12 14.03.02-11.83-2.25-2.2h-14.89zm.06-58.02 14.26-14.45 2.89-2.96h.03l.02-.02h10.95v.02h32.27l-.02-.03h-43.24l-17.22 17.44v.05h.06v-.05zm60.45-.02v40.41h.01v17.63h.01l17.25-17.63v-40.46l-17.26-17.31V145h-.01zm-43.24 2.55v-2.38h-.01l.01 2.38zM405.77 46.39l.11 9.02-.05.01.01 10.01 17.35-7.52v-.04l64.14-28.36 12.25-5.33-21.74-9.49-72.07 31.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m405.92 185.44 17.19 17.6h77.6l-.08-.07.03-14.52-.08-.08v-2.96h-.08v17.49h-77.24v-17.49h-.07V81.72l-17.34-.02.07 103.74zM521.2 14.77l.06-.03-21.82-9.56-.03.02 9.51 4.2 12.28 5.37zM508.92 9.4l-9.51-4.2-.04.02 9.55 4.18zm6.11 121.17-14.26 14.45v.05h.1l14.16-14.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m500.66 188.45-.03 14.52.08.07h14.89l-14.94-14.59zm28.26-60.86h-10.95l-.02.02h10.97v-.02zm-105.66 57.82h77.24v17.48h-77.24z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-7)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M423.26 185.41h77.24v17.48h-77.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-8)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M518.14 185.41h43.08-43.08z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M518.21 203.04h43.02v.03h-43.02z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M561.22 185.41h-43.08l.07 17.63h43.02v-17.63h-.01z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-9)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M561.22 185.41h-43.08l.07 17.63h43.02v-17.63h-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-10)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M561.23 127.61h-.04l.04.03v-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-11)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M517.98 145.01v.16l43.24-.17v-.01h-32.1v.03l-11.14-.01z"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M517.98 144.99h11.14v.03h-11.14z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-12)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M517.98 144.99h11.14v.03h-11.14z"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M517.97 145.17h.01v-.16h-.01v.16z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-13)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M517.97 145.17h.01v-.16h-.01v.16z"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m517.92 127.61-2.89 2.96 2.92-2.96h-.03z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-14)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "m517.92 127.61-2.89 2.96 2.92-2.96h-.03z"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M529.12 144.99h32.1v.01h.01v-17.36l-.04-.03h-32.27l.2 17.38z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-15)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M529.12 144.99h32.1v.01h.01v-17.36l-.04-.03h-32.27l.2 17.38z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M517.97 145.07v-.06h.01v-.02h11.14l-.2-17.38h-10.97l-2.92 2.96-14.16 14.5h17.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-16)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M517.97 145.07v-.06h.01v-.02h11.14l-.2-17.38h-10.97l-2.92 2.96-14.16 14.5h17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-17)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "m423.22 81.72.06-23.85-.09.04v23.81h.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-18)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M405.77 65.46V81.7h.08l-.01-16.27-.07.03z"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m405.85 81.7 17.34.02V57.91l-17.35 7.52.01 16.27z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-19)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "m405.85 81.7 17.34.02V57.91l-17.35 7.52.01 16.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-20)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M518.09 185.41h.05l-.16-37.86v37.86h.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-21)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M500.71 170.77v-25.53h-.01l.01-.01v-.16h-.13v40.34h.09l.04-14.64z"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M518.09 203.04h-.23l-.01 2.2.37.35-.01-2.52h-.12v-.03z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m500.71 170.77-.04 14.64h.04v-14.64z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-22)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "m500.71 170.77-.04 14.64h.04v-14.64z"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m515.6 203.04 2.25 2.2.01-2.2h-2.26z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-23)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "m515.6 203.04 2.25 2.2.01-2.2h-2.26z"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M500.77 145.17v-.1h-.06v.16l.06-.06z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-24)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M500.77 145.17v-.1h-.06v.16l.06-.06z"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M500.71 145.24v25.53l.06-25.53h-.06z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-25)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M500.71 145.24v25.53l.06-25.53h-.06z"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m517.98 185.41-.01-40.05.01 40.05v-37.86l-.01-2.38-.11 57.87h.23v-17.63h-.11z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-26)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "m517.98 185.41-.01-40.05.01 40.05v-37.86l-.01-2.38-.11 57.87h.23v-17.63h-.11z"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m500.66 188.45.01-3.04h-.09v2.96l.08.08z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-27)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "m500.66 188.45.01-3.04h-.09v2.96l.08.08z"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M500.77 145.07v.1l.1-.1h-.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-28)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M500.77 145.07v.1l.1-.1h-.1z"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m517.86 203.04.11-57.87-17.2.07-.06 25.53v14.64h-.04l-.01 3.04 14.94 14.59h2.26z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-29)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "m517.86 203.04.11-57.87-17.2.07-.06 25.53v14.64h-.04l-.01 3.04 14.94 14.59h2.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-30)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M518.09 203.04h.12v.03h-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-31)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M518.09 203.04h.12v.03h-.12z"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M518.09 203.04h.12l-.07-17.63h-.05v17.63z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-34)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M518.09 203.04h.12l-.07-17.63h-.05v17.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-35)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M518.09 203.04h.12l-.07-17.63h-.05v17.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-36)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M500.7 145.24h.01v-.01l-.01.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-37)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M500.7 145.24h.01v-.01l-.01.01z"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m500.77 145.17-.06.06v.01h.06v-.07z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-38)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "m500.77 145.17-.06.06v.01h.06v-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-39)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "m500.77 145.17-.06.06v.01h.06v-.07z"
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M517.97 145.17v-.1h-17.1l-.1.1v.07l17.2-.07z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-42)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M517.97 145.17v-.1h-17.1l-.1.1v.07l17.2-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-43)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M517.97 145.17v-.1h-17.1l-.1.1v.07l17.2-.07z"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m578.73 58.74 3.14 1.37-3.14-1.37zm0 6.74v17.37h17.79v-.11h-17.77l-.02-17.26zm-97.75-52.21-3.18 1.4.04.02 3.12-1.38.02-.04zM596.52 66.5V47.88l-17.9 10.66-79.04-34.37v.01l79.15 34.56 3.14 1.37 14.65 6.39z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m499.37 5.22-.08-.04-18.31 8.09-.02.04 18.41-8.09z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m499.53 24.15 21.67-9.38-12.28-5.37 8.75 3.86.08.19-18.42 8.14-18.43-8.14.06-.14-3.12 1.38 21.74 9.49v-.01l-.05-.02z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m480.96 13.31-.06.14 18.43 8.14 18.42-8.14-.08-.19-8.75-3.86-9.55-4.18-18.41 8.09z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-44)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "m578.73 39.96 17.79 7.78v.14l.33-.2-75.59-32.94-.06.03 57.53 25.19z"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m521.2 14.77.06-.03-.06.03z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-45)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "m521.2 14.77.06-.03-.06.03z"
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M578.73 39.96 521.2 14.77l-21.62 9.4 79.04 34.37 17.9-10.66v-.14l-17.79-7.78z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-46)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M578.73 39.96 521.2 14.77l-21.62 9.4 79.04 34.37 17.9-10.66v-.14l-17.79-7.78z"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m521.2 14.77-21.67 9.38.05.02 21.62-9.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-47)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "m521.2 14.77-21.67 9.38.05.02 21.62-9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-48)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M596.52 66.51v16.23V66.5v.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-49)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M578.73 58.74v6.74-6.74z"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m581.87 60.11-3.14-1.37v6.74l.02 17.26h17.77V66.51l-14.65-6.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-50)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "m581.87 60.11-3.14-1.37v6.74l.02 17.26h17.77V66.51l-14.65-6.4z"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M596.52 66.51v-.01l-14.65-6.39 14.65 6.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-51)",
      opacity: 0.56,
      mixBlendMode: "multiply",
      strokeWidth: 0
    },
    d: "M596.52 66.51v-.01l-14.65-6.39 14.65 6.4z"
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m296.59 81.56-.05-1.13h-.03v1.13h.08z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m296.59 81.56-.05-1.13h-.03v1.13h.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.15 22.44h7.69v38.94h44.38V22.3c9.83.39 19.39-1.43 28.68 1.44 6.44 1.99 10.38 7.06 10.79 13.47.67 10.3.18 20.68.18 31.39H125.86c-13.75 0-17.39-3.6-17.44-17.43-.06-16.02-.01-32.04-.02-48.06V.01h7.66v3.75c0 16.38-.01 32.76 0 49.13 0 7.02 1.66 8.69 8.61 8.72 5.84.03 46.26 0 52.46 0V25.8h7.43v35.57h17.08v-35.6h7.73v35.64h16.76V22.44Zm84.55 39c0-7.21.27-14.02-.08-20.79-.32-6.27-4-10.35-10.18-11.07-4.77-.56-9.67-.11-14.5-.11v31.98h24.75Zm-269.16.06h44.37V22.55h7.55v45.82H0v-6.62h34.53c-.45-8.54-.37-16.75-1.49-24.79-.71-5.12-5.34-7.54-11.9-7.72-4.51-.13-9.04-.02-13.77-.02v-6.31c7 0 13.98-.71 20.75.18 8.19 1.08 12.87 7.41 13.28 16.29.27 5.97.11 11.95.14 17.93v4.2ZM86.46 7.92c-.3 0-.54.24-.54.54v7.45h6.97c.3 0 .54-.24.54-.54V8.46c0-.3-.24-.54-.54-.54h-6.43ZM42.54 84.01v40.78h-4.83V90.04c-.13-.04-.27-.08-.4-.11-.32.7-.68 1.38-.94 2.09-3.82 10.25-7.66 20.5-11.39 30.78-.6 1.66-1.38 2.47-3.17 2.16a5.89 5.89 0 0 0-1.92 0c-1.41.23-1.95-.47-2.41-1.71-3.91-10.6-7.87-21.18-11.83-31.76-.2-.53-.41-1.05-.94-1.56v34.88H0V84.14h7.94c4.32 11.61 8.68 23.31 13.23 35.51.58-1.46 1.03-2.52 1.43-3.6 3.74-10.05 7.5-20.1 11.18-30.18.53-1.45 1.26-1.99 2.79-1.88 1.9.13 3.83.03 5.97.03Zm149.33.01c1.75 0 3.4-.15 4.99.07.67.09 1.39.86 1.81 1.5 6.53 9.92 13.02 19.88 19.52 29.83.42.65.86 1.28 1.68 1.87V84.13h4.63v40.81c-1.69 0-3.39.13-5.05-.07-.59-.07-1.2-.86-1.59-1.46-6.59-10.06-13.15-20.13-19.72-30.2-.42-.64-.86-1.26-1.66-2.41v34.03h-4.61V84.02Zm91.63.38c6.89 0 13.68-.5 20.37.13 7.31.69 11.63 5.27 13.18 12.6 1.04 4.93 1.02 9.93-.05 14.85-1.75 8.03-6.84 12.33-15.62 12.82-5.89.33-11.81.06-17.88.06V84.39Zm4.85 3.81v32.35c3.8 0 7.43.17 11.05-.03 7.46-.42 11.61-3.39 12.46-9.55.57-4.17.51-8.51.06-12.7-.51-4.77-3.33-8.39-8.23-9.13-5.01-.76-10.15-.66-15.33-.94Zm-229.44-4.1h4.86v2.38c0 7.48-.04 14.97.01 22.45.06 8.74 2.99 11.62 11.73 11.67 3.19.02 6.38 0 9.84 0V84.13h4.95v40.5c-.06.06-.17.24-.27.24-6.13 0-12.27.28-18.38-.07-7.83-.45-12.24-4.52-12.64-12.33-.48-9.37-.11-18.78-.11-28.35Zm83.93 40.83c5.35-13.79 10.61-27.33 15.83-40.79.29-.06.42-.11.56-.11q5.32-.23 7.22 4.66c4.39 11.31 8.78 22.63 13.16 33.94.25.65.48 1.31.83 2.3-1.65 0-3.11.11-4.54-.06-.49-.06-1.1-.74-1.32-1.27a165.12 165.12 0 0 1-2.88-7.79c-.4-1.16-.97-1.67-2.29-1.65-5.19.09-10.39.07-15.59.01-1.23-.01-1.91.25-2.31 1.56-.76 2.44-1.88 4.76-2.62 7.2-.47 1.55-1.17 2.25-2.82 2.03-.96-.13-1.96-.02-3.24-.02Zm18.98-35.78c-.16 0-.33 0-.49-.01-2.51 6.8-5.02 13.59-7.58 20.52h15.65c-2.58-6.98-5.08-13.74-7.57-20.51Zm-29.25-4.96v4.27c-3.13 0-6.18-.01-9.22 0-2.63.01-5.28-.07-7.9.13-3.53.27-5.48 2.76-5.44 6.64.04 3.94 1.95 6.36 5.47 6.62 2.41.18 4.84.09 7.26.14 9.92.23 12.38 6.44 11.42 13.95-.68 5.33-3.57 8.34-9.15 8.74-6.35.45-12.76.1-19.25.1v-4.19h2.23c4.63 0 9.26.06 13.89-.02 5.22-.09 7.55-2.64 7.29-7.79-.2-3.96-2.33-6.12-6.33-6.29-2.35-.1-4.7 0-7.05-.1-8.67-.33-11.66-5.65-10.77-13.23.67-5.67 3.64-8.61 9.36-8.91 6.01-.32 12.06-.07 18.2-.07Zm139.09 35.37h-26.84v-12.13h24.43v-5.59h-24.4V89.49h24.38v-5.15h-29.61v40.7h32.03v-5.47Z",
    style: {
      fill: "#7a7b7b",
      strokeWidth: 0
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M15.34 154.5c.18.18.4.33.64.43.24.11.5.16.79.16s.55-.05.79-.16.45-.25.64-.43.33-.4.43-.64c.11-.24.16-.5.16-.79s-.05-.55-.16-.79-.25-.45-.43-.64-.4-.33-.64-.43-.5-.16-.79-.16-.55.05-.79.16-.46.25-.64.43-.33.4-.43.64c-.11.24-.16.5-.16.79s.05.55.16.79.25.45.43.64Zm-4.73 0c.18.18.4.33.64.43.24.11.5.16.79.16s.55-.05.79-.16.45-.25.64-.43c.18-.18.33-.4.43-.64.11-.24.16-.5.16-.79s-.05-.55-.16-.79a2.32 2.32 0 0 0-.43-.64 2.025 2.025 0 0 0-1.43-.59c-.29 0-.55.05-.79.16s-.46.25-.64.43-.33.4-.43.64c-.11.24-.16.5-.16.79s.05.55.16.79.25.45.43.64Zm-4.88 17.21c.93.15 2.02.22 3.27.22h18.19V159h-4.1v9.48H10.08c-1.33 0-2.4-.06-3.23-.18s-1.47-.32-1.93-.59c-.46-.27-.78-.62-.94-1.05-.16-.43-.24-.95-.24-1.57 0-.4.03-.8.09-1.2.06-.4.12-.8.2-1.2l-3.64-.32c-.05.27-.1.57-.14.88l-.12.94c-.04.31-.07.61-.09.89-.02.28-.03.53-.03.74 0 .56.05 1.09.15 1.61.1.52.27 1 .52 1.45.25.45.59.86 1.02 1.24.43.37.98.69 1.65.96.67.27 1.47.48 2.4.62Zm26.74-1.22c.4.46.92.81 1.55 1.06s1.38.38 2.26.38h2.95c1.79 0 3.14-.66 4.07-1.97.28.25.6.51.95.76.35.26.76.49 1.23.69s.99.37 1.58.5c.58.13 1.25.19 2 .19 1.04 0 1.96-.18 2.77-.53.8-.35 1.48-.82 2.03-1.41.55-.59.96-1.26 1.25-2.02.28-.76.43-1.55.43-2.37 0-.51-.06-1.05-.18-1.6s-.3-1.09-.55-1.61a7.58 7.58 0 0 0-.93-1.47c-.37-.46-.82-.87-1.33-1.21s-1.09-.62-1.73-.83c-.64-.21-1.35-.31-2.13-.31-.55 0-1.16.1-1.84.29-.68.19-1.37.58-2.07 1.15-.7.57-1.39 1.39-2.05 2.44-.66 1.06-1.25 2.44-1.77 4.16-.18.58-.46 1-.85 1.28-.39.27-.84.41-1.36.41h-1.47c-.32 0-.59-.04-.83-.12-.24-.08-.43-.22-.58-.42-.15-.2-.27-.47-.35-.81-.08-.34-.12-.78-.12-1.3v-16.55h-4.1v17.41c0 .78.1 1.49.28 2.14.19.65.49 1.2.89 1.66Zm12.6-5.01c.25-.65.54-1.23.87-1.74s.71-.91 1.14-1.22c.43-.31.89-.47 1.4-.47s.99.12 1.4.37c.4.25.74.56 1.02.92.27.37.48.76.62 1.19.14.43.21.82.21 1.19 0 .55-.08 1.01-.24 1.39-.16.38-.39.69-.69.92-.3.24-.66.41-1.08.52a5.536 5.536 0 0 1-2.5.05c-.39-.08-.75-.18-1.11-.3-.36-.12-.68-.25-.96-.4-.28-.15-.5-.29-.63-.43.14-.68.33-1.35.58-2Zm21.72 6.01c.89-.29 1.62-.7 2.18-1.21.58.49 1.28.89 2.1 1.2.82.31 1.82.46 3.01.46h24.2v-22.67h-4.1v19.21h-5.11c-.25 0-.47-.14-.64-.41-.17-.27-.32-.64-.45-1.1-.13-.46-.24-.98-.34-1.58-.1-.59-.2-1.22-.29-1.87-.13-.79-.34-1.51-.65-2.18-.31-.66-.72-1.23-1.22-1.71-.51-.48-1.11-.85-1.81-1.12-.7-.27-1.51-.4-2.43-.4s-1.76.08-2.49.24c-.74.16-1.47.36-2.21.58v3.25c.32-.14.66-.26 1.03-.36a11.89 11.89 0 0 1 2.08-.39c.32-.03.58-.05.8-.05.65 0 1.18.15 1.58.44.4.29.72.68.96 1.14.24.47.42 1 .54 1.59s.22 1.18.31 1.77c.06.4.16.79.28 1.17.13.38.26.71.39.99H74.13c-.68 0-1.34-.06-1.96-.17-.63-.12-1.21-.3-1.74-.55.12-.49.17-1 .17-1.51 0-1.44-.54-2.96-1.61-4.57-1.07-1.6-2.63-3.25-4.68-4.95l-2.97 2.9c.64.52 1.27 1.07 1.9 1.66.63.59 1.19 1.19 1.69 1.8s.9 1.2 1.21 1.79c.3.59.46 1.14.46 1.64 0 .28-.04.55-.11.79s-.22.45-.43.62c-.21.17-.51.31-.91.4s-.91.14-1.54.14h-6.06v3.45h5.98c1.28 0 2.37-.15 3.26-.44Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M79.37 154.5c.18.18.4.33.64.43.24.11.5.16.79.16s.55-.05.79-.16.45-.25.64-.43.33-.4.43-.64c.11-.24.16-.5.16-.79s-.05-.55-.16-.79-.25-.45-.43-.64-.4-.33-.64-.43-.5-.16-.79-.16-.55.05-.79.16-.46.25-.64.43-.33.4-.43.64c-.11.24-.16.5-.16.79s.05.55.16.79.25.45.43.64Zm40.02-.82c.18.18.4.33.64.43.24.11.51.16.79.16s.55-.05.79-.16c.24-.1.46-.25.64-.43s.33-.4.43-.64.16-.5.16-.79-.05-.55-.16-.79a2.32 2.32 0 0 0-.43-.64 2.025 2.025 0 0 0-1.43-.59c-.29 0-.55.05-.79.16s-.45.25-.64.43c-.18.18-.33.4-.43.64-.11.24-.16.5-.16.79s.05.55.16.79.25.45.43.64Zm-4.74 0c.18.18.4.33.64.43.24.11.51.16.79.16s.55-.05.79-.16c.24-.1.45-.25.64-.43s.33-.4.43-.64.16-.5.16-.79-.05-.55-.16-.79a2.32 2.32 0 0 0-.43-.64c-.18-.18-.4-.33-.64-.43-.24-.1-.51-.16-.79-.16s-.55.05-.79.16-.45.25-.64.43c-.18.18-.33.4-.43.64-.11.24-.16.5-.16.79s.05.55.16.79.25.45.43.64Zm-3.49 15.98c.59.41 1.25.71 1.97.91.73.19 1.44.29 2.15.29s1.38-.07 2.02-.22a8.5 8.5 0 0 0 1.99-.76c.14.28.32.55.55.8.23.25.53.46.89.65.36.18.8.33 1.32.44s1.13.17 1.85.17h4.91c.79 0 1.46-.12 2.01-.35a3.78 3.78 0 0 0 1.37-.95c.57.39 1.22.7 1.96.94s1.64.35 2.69.35h3.25c.79 0 1.46-.12 2.01-.35a3.78 3.78 0 0 0 1.37-.95c.57.39 1.22.7 1.96.94s1.64.35 2.69.35h22.53v-5.9c0-1.16-.14-2.23-.43-3.23-.28-1-.72-1.87-1.3-2.6-.58-.74-1.32-1.31-2.21-1.74-.89-.42-1.94-.63-3.15-.63-1.29 0-2.48.24-3.57.73a11.99 11.99 0 0 0-2.99 1.89v-11.17h-4.1v16.33c-.28.52-.54 1.02-.77 1.5-.23.48-.42.94-.59 1.37h-3.38c-.64 0-1.26-.05-1.85-.16-.59-.1-1.15-.26-1.66-.47l.06-.54c.02-.18.02-.37.02-.56v-7.73h-4.1v7.18c0 .44-.04.81-.11 1.1-.07.29-.19.53-.34.7-.15.17-.35.3-.6.37s-.54.11-.89.11h-1.8c-.64 0-1.26-.05-1.85-.16-.59-.1-1.15-.26-1.66-.47l.06-.54c.02-.18.02-.37.02-.56v-7.73h-4.1v7.18c0 .44-.04.81-.11 1.1-.07.29-.19.53-.34.7-.15.17-.35.3-.6.37s-.54.11-.89.11h-2.79c-.33 0-.59-.03-.78-.09s-.35-.17-.46-.32c-.11-.15-.18-.35-.22-.6s-.06-.56-.06-.94v-10.19h-4.07v1.78c-.61.15-1.28.33-2 .54-.73.21-1.45.47-2.19.76-.73.3-1.44.65-2.11 1.05-.68.4-1.28.86-1.81 1.37s-.95 1.1-1.27 1.74c-.32.65-.47 1.37-.47 2.17 0 .9.19 1.68.56 2.33s.85 1.18 1.44 1.59Zm45.67-3.97c.54-.88 1.13-1.65 1.77-2.31.65-.66 1.33-1.19 2.05-1.58s1.43-.58 2.14-.58c.52 0 1 .08 1.47.25.46.17.86.45 1.2.84.34.39.6.92.8 1.59.2.66.3 1.48.3 2.46v2.11H155.5c.35-.98.79-1.91 1.33-2.78Zm-43.32-1.7c.28-.42.68-.79 1.2-1.12.52-.33 1.14-.63 1.87-.88.73-.26 1.54-.48 2.44-.67v5.35c-.42.27-.91.49-1.47.66-.56.17-1.14.25-1.74.25-.33 0-.65-.04-.98-.11-.33-.07-.62-.2-.88-.37-.26-.17-.47-.4-.63-.69s-.24-.63-.24-1.04c0-.5.14-.96.42-1.38Zm20.77 10.61c-.24-.11-.5-.16-.79-.16s-.55.05-.79.16a2.003 2.003 0 0 0-1.07 1.07c-.11.24-.16.5-.16.79s.05.55.16.79.25.45.43.64.4.33.64.43c.24.1.5.16.79.16s.55-.05.79-.16.45-.25.64-.43c.18-.18.33-.4.43-.64.11-.24.16-.5.16-.79s-.05-.55-.16-.79a2.32 2.32 0 0 0-.43-.64c-.18-.18-.4-.33-.64-.43Zm-4.73 0c-.24-.11-.5-.16-.79-.16s-.55.05-.79.16a2.003 2.003 0 0 0-1.07 1.07c-.11.24-.16.5-.16.79s.05.55.16.79.25.45.43.64a2.025 2.025 0 0 0 1.43.59c.29 0 .55-.05.79-.16s.46-.25.64-.43.33-.4.43-.64c.11-.24.16-.5.16-.79s-.05-.55-.16-.79a2.32 2.32 0 0 0-.43-.64c-.18-.18-.4-.33-.64-.43Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M141.14 154.5c.18.18.4.33.64.43s.51.16.79.16.55-.05.79-.16.45-.25.64-.43.33-.4.43-.64c.11-.24.16-.5.16-.79s-.05-.55-.16-.79-.25-.45-.43-.64-.4-.33-.64-.43c-.24-.11-.51-.16-.79-.16s-.55.05-.79.16-.45.25-.64.43-.33.4-.43.64c-.11.24-.16.5-.16.79s.05.55.16.79.25.45.43.64Zm45.16 20.13c.73-.79 1.29-1.69 1.66-2.7h10.84v-22.67h-4.1v19.21h-6.48v-2.44c0-1.03-.1-1.94-.29-2.71-.19-.78-.46-1.45-.79-2.01-.33-.56-.71-1.03-1.14-1.4a5.795 5.795 0 0 0-2.85-1.33c-.5-.08-.99-.13-1.45-.13-1.14 0-2.16.19-3.08.58-.91.39-1.7.91-2.34 1.57-.65.66-1.15 1.42-1.5 2.29-.35.87-.53 1.78-.53 2.74 0 .72.13 1.45.4 2.19.27.75.7 1.43 1.31 2.03.6.61 1.4 1.11 2.37 1.49.98.38 2.18.58 3.6.58h1.91c-.26.44-.63.86-1.1 1.25s-1.03.75-1.67 1.06c-.65.32-1.38.58-2.2.79-.82.21-1.71.35-2.68.41l.38 3.38c1.35-.14 2.63-.38 3.84-.74s2.32-.83 3.31-1.4c.99-.58 1.86-1.26 2.59-2.05Zm-4.39-6.15c-1.33 0-2.3-.29-2.91-.88s-.92-1.38-.92-2.39c0-.51.09-.99.26-1.41.17-.43.4-.79.69-1.1.28-.3.61-.54.99-.71.37-.17.76-.25 1.16-.25.37 0 .73.07 1.09.21.36.14.68.4.95.78.28.38.51.91.68 1.59.17.68.26 1.56.26 2.64v1.51h-2.24Zm20.99-19.2h4.1v22.67h-4.1zm25.2 4.4c.18.18.4.33.64.43.24.11.51.16.79.16s.55-.05.79-.16c.24-.1.46-.25.64-.43s.33-.4.43-.64.16-.5.16-.79-.05-.55-.16-.79a2.32 2.32 0 0 0-.43-.64 2.025 2.025 0 0 0-1.43-.59c-.29 0-.55.05-.79.16s-.45.25-.64.43c-.18.18-.33.4-.43.64-.11.24-.16.5-.16.79s.05.55.16.79.25.45.43.64Zm-4.73 0c.18.18.4.33.64.43.24.11.51.16.79.16s.55-.05.79-.16c.24-.1.45-.25.64-.43s.33-.4.43-.64.16-.5.16-.79-.05-.55-.16-.79a2.32 2.32 0 0 0-.43-.64c-.18-.18-.4-.33-.64-.43-.24-.1-.51-.16-.79-.16s-.55.05-.79.16-.45.25-.64.43c-.18.18-.33.4-.43.64-.11.24-.16.5-.16.79s.05.55.16.79.25.45.43.64Zm47.98.82c.18.18.4.33.64.43s.51.16.79.16.55-.05.79-.16.45-.25.64-.43.33-.4.43-.64c.11-.24.16-.5.16-.79s-.05-.55-.16-.79-.25-.45-.43-.64-.4-.33-.64-.43c-.24-.11-.51-.16-.79-.16s-.55.05-.79.16-.45.25-.64.43-.33.4-.43.64c-.11.24-.16.5-.16.79s.05.55.16.79.25.45.43.64Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M303.46 168.48h-3.75c-.76 0-1.48-.07-2.17-.21-.69-.14-1.31-.37-1.87-.67a6.526 6.526 0 0 0 .25-1.81c0-.51-.06-1.05-.18-1.6s-.3-1.09-.55-1.61a7.58 7.58 0 0 0-.93-1.47c-.37-.46-.82-.87-1.33-1.21s-1.09-.62-1.73-.83c-.64-.21-1.35-.31-2.13-.31-.55 0-1.16.1-1.84.29-.68.19-1.37.58-2.07 1.15-.7.57-1.39 1.39-2.05 2.44-.66 1.06-1.25 2.44-1.77 4.16-.18.58-.46 1-.85 1.28-.39.27-.84.41-1.36.41h-.77c-.64 0-1.26-.05-1.85-.16-.59-.1-1.15-.26-1.66-.47l.06-.54c.02-.18.02-.37.02-.56v-7.73h-4.1v7.18c0 .44-.04.81-.11 1.1-.07.29-.19.53-.34.7-.15.17-.35.3-.6.37s-.54.11-.89.11h-4.45v-2.44c0-1.16-.14-2.23-.42-3.23-.28-1-.71-1.87-1.3-2.6-.58-.74-1.32-1.31-2.22-1.74-.9-.42-1.96-.63-3.19-.63-1.06 0-2.06.17-3 .51-.94.34-1.81.8-2.61 1.36-.8.57-1.54 1.22-2.21 1.96s-1.28 1.5-1.81 2.29-1 1.57-1.39 2.36-.72 1.51-.97 2.17c-.59-.02-1.22-.09-1.89-.21a5.47 5.47 0 0 1-1.86-.68c.03-.28.05-.57.05-.85v-4.61h-4.1v4.05c0 .44-.04.81-.11 1.1-.07.29-.19.53-.34.7-.15.17-.35.3-.6.37s-.54.11-.89.11h-2.27c-.33 0-.59-.03-.78-.09s-.35-.17-.46-.32c-.11-.15-.18-.35-.22-.6s-.06-.56-.06-.94v-10.19h-4.07v1.78c-.61.15-1.28.33-2 .54-.73.21-1.45.47-2.19.76-.73.3-1.44.65-2.11 1.05-.68.4-1.28.86-1.81 1.37s-.95 1.1-1.27 1.74c-.32.65-.47 1.37-.47 2.17 0 .9.19 1.68.56 2.33s.85 1.18 1.44 1.59c.59.41 1.25.71 1.97.91.73.19 1.44.29 2.15.29s1.38-.07 2.02-.22a8.5 8.5 0 0 0 1.99-.76c.14.28.32.55.55.8.23.25.53.46.89.65.36.18.8.33 1.32.44s1.13.17 1.85.17h4.38c.89 0 1.64-.15 2.23-.44s1.07-.68 1.44-1.17c.69.58 1.56.99 2.61 1.24 1.05.25 2.28.37 3.69.37h23.34c.79 0 1.46-.12 2.01-.35a3.78 3.78 0 0 0 1.37-.95c.57.39 1.22.7 1.96.94s1.64.35 2.69.35h1.31c1.79 0 3.14-.66 4.07-1.97.28.25.6.51.95.76.35.26.76.49 1.23.69s.99.37 1.58.5c.58.13 1.25.19 2 .19 1.07 0 2.01-.18 2.82-.55s1.49-.86 2.05-1.47a6.53 6.53 0 0 0 2.15 1.32c.44.17.92.3 1.44.39.44.07.92.11 1.42.12h8.21v-22.67h-4.1v19.21Zm-75.73-1.81c-.42.27-.91.49-1.47.66-.56.17-1.14.25-1.74.25-.33 0-.65-.04-.98-.11-.33-.07-.62-.2-.88-.37-.26-.17-.47-.4-.63-.69s-.24-.63-.24-1.04c0-.5.14-.96.42-1.38.28-.42.68-.79 1.2-1.12.52-.33 1.14-.63 1.87-.88.73-.26 1.54-.48 2.44-.67v5.35Zm32.6 1.81h-11.05c.35-.98.79-1.91 1.32-2.78.54-.88 1.13-1.65 1.77-2.31.65-.66 1.33-1.19 2.05-1.58.72-.39 1.43-.58 2.14-.58.51 0 1 .08 1.47.25.46.17.86.45 1.2.84.34.39.6.92.8 1.59.2.66.3 1.48.3 2.46v2.11Zm31.53-1.36c-.16.38-.39.69-.69.92-.3.24-.66.41-1.08.52a5.536 5.536 0 0 1-2.5.05c-.39-.08-.75-.18-1.11-.3-.36-.12-.68-.25-.96-.4-.28-.15-.5-.29-.63-.43.14-.68.33-1.35.58-2 .25-.65.54-1.23.87-1.74s.71-.91 1.14-1.22c.43-.31.89-.47 1.4-.47s.99.12 1.4.37c.4.25.74.56 1.02.92.27.37.48.76.62 1.19.14.43.21.82.21 1.19 0 .55-.08 1.01-.24 1.39Zm19.8-17.84h4.1v22.67h-4.1zM15.6 194.2a2 2 0 0 0-.82-.16c-.3 0-.57.05-.82.16s-.47.26-.66.45-.34.41-.45.66-.16.52-.16.82.05.57.16.82.26.47.45.66.41.34.66.45.52.16.82.16.57-.05.82-.16a2.148 2.148 0 0 0 1.11-1.11c.11-.25.16-.52.16-.82s-.05-.57-.16-.82a2.148 2.148 0 0 0-1.11-1.11Zm-4.91 0a2 2 0 0 0-.82-.16c-.3 0-.57.05-.82.16s-.47.26-.66.45-.34.41-.45.66-.16.52-.16.82.05.57.16.82.26.47.45.66.41.34.66.45.52.16.82.16.57-.05.82-.16a2.148 2.148 0 0 0 1.11-1.11c.11-.25.16-.52.16-.82s-.05-.57-.16-.82a2.148 2.148 0 0 0-1.11-1.11Zm29.9 25.58c-.19-.19-.41-.34-.66-.45s-.52-.16-.82-.16-.57.05-.82.16a2.148 2.148 0 0 0-1.11 1.11c-.11.25-.16.52-.16.82s.05.57.16.82.26.47.45.66c.19.19.41.34.66.45s.52.16.82.16.57-.05.82-.16.47-.26.66-.45.34-.41.45-.66.16-.52.16-.82-.05-.57-.16-.82-.26-.47-.45-.66Zm-4.91 0c-.19-.19-.41-.34-.66-.45s-.52-.16-.82-.16-.57.05-.82.16a2.148 2.148 0 0 0-1.11 1.11c-.11.25-.16.52-.16.82s.05.57.16.82.26.47.45.66c.19.19.41.34.66.45s.52.16.82.16.57-.05.82-.16.47-.26.66-.45.34-.41.45-.66.16-.52.16-.82-.05-.57-.16-.82-.26-.47-.45-.66Zm44.35-6.8H42.62c-.67 0-1.31-.05-1.92-.16s-1.19-.27-1.73-.49l.06-.56c.02-.19.02-.38.02-.58v-8.02h-4.26v7.45c0 .46-.04.84-.11 1.15s-.19.55-.35.73c-.16.18-.37.31-.62.38-.26.08-.57.11-.93.11H18.72c-.34 0-.61-.03-.81-.1a.986.986 0 0 1-.48-.34c-.11-.16-.19-.37-.23-.62s-.06-.58-.06-.97v-10.58h-4.22v1.85c-.63.15-1.33.34-2.08.56s-1.51.48-2.27.79c-.76.31-1.49.67-2.19 1.09-.7.41-1.33.89-1.88 1.42s-.99 1.14-1.32 1.81-.49 1.42-.49 2.25c0 .94.19 1.74.58 2.41.39.67.89 1.22 1.5 1.65s1.29.74 2.05.94 1.5.3 2.23.3 1.43-.08 2.1-.23 1.35-.41 2.06-.79c.14.29.33.57.57.83s.55.48.93.67c.38.19.83.34 1.37.46s1.17.17 1.92.17h16.26c.82 0 1.51-.12 2.08-.36s1.05-.57 1.43-.98c.59.4 1.27.73 2.03.97.49.16 1.06.26 1.68.32.02 0 .03 0 .04.01.16.03.38.04.64.04H84.3v-23.53h-4.26v19.94Zm-67.11-1.88c-.44.28-.94.51-1.52.69s-1.18.26-1.8.26c-.34 0-.68-.04-1.02-.11s-.64-.2-.91-.38-.49-.42-.65-.71-.25-.65-.25-1.08c0-.52.14-1 .43-1.43.29-.43.7-.82 1.24-1.16.54-.34 1.19-.65 1.94-.92s1.6-.5 2.54-.7v5.55Zm80.78-16.05a2 2 0 0 0-.82-.16c-.3 0-.57.05-.82.16s-.47.26-.66.45-.34.41-.45.66-.16.52-.16.82.05.57.16.82.26.47.45.66.41.34.66.45.52.16.82.16.57-.05.82-.16a2.148 2.148 0 0 0 1.11-1.11c.11-.25.16-.52.16-.82s-.05-.57-.16-.82a2.148 2.148 0 0 0-1.11-1.11Zm23.07.45c-.19-.19-.41-.34-.66-.45s-.52-.16-.82-.16-.57.05-.82.16a2.148 2.148 0 0 0-1.11 1.11c-.11.25-.16.52-.16.82s.05.57.16.82.26.47.45.66c.19.19.41.34.66.45s.52.16.82.16.57-.05.82-.16.47-.26.66-.45.34-.41.45-.66.16-.52.16-.82-.05-.57-.16-.82-.26-.47-.45-.66Zm41.53 17.48h-3.9c-.79 0-1.54-.07-2.25-.22s-1.36-.38-1.94-.7c.09-.31.15-.62.2-.93s.07-.63.07-.95c0-.53-.06-1.09-.19-1.66s-.32-1.13-.57-1.67c-.26-.54-.58-1.05-.97-1.53s-.85-.9-1.38-1.26-1.13-.65-1.79-.86-1.4-.32-2.21-.32c-.57 0-1.2.1-1.91.3-.7.2-1.42.6-2.15 1.2s-1.44 1.44-2.13 2.54-1.3 2.53-1.83 4.31c-.19.6-.48 1.04-.88 1.33s-.87.43-1.41.43h-11.97c-.67 0-1.31-.05-1.92-.16s-1.19-.27-1.73-.49l.06-.56c.02-.19.02-.38.02-.58v-8.02h-4.26v7.45c0 .46-.04.84-.11 1.15s-.19.55-.35.73c-.16.18-.37.31-.62.38-.26.08-.57.11-.93.11H95.07v-9.84h-4.26v11.3c0 .76-.06 1.43-.17 2.01-.11.57-.33 1.07-.65 1.49s-.78.77-1.37 1.06-1.36.52-2.31.7l.56 3.63c1.21-.19 2.27-.45 3.18-.79s1.69-.77 2.35-1.31 1.18-1.18 1.58-1.95.69-1.67.86-2.72h17.86c.82 0 1.51-.12 2.08-.36s1.05-.57 1.43-.98c.59.4 1.27.73 2.03.97.49.16 1.06.26 1.68.32.02 0 .03 0 .04.01.16.03.38.04.64.04h12.95c1.86 0 3.26-.68 4.22-2.05.29.26.62.53.99.79.36.27.79.51 1.28.72.48.21 1.03.38 1.64.52.6.13 1.3.2 2.07.2 1.11 0 2.09-.19 2.93-.57s1.55-.89 2.13-1.52c.31.28.64.54 1.01.77s.77.43 1.23.61c.45.17.95.31 1.5.4.45.08.95.11 1.48.13h8.52v-23.53h-4.26v19.94Zm-12.03-1.41c-.16.39-.4.71-.71.96-.31.25-.69.43-1.12.54a5.912 5.912 0 0 1-2.6.05c-.4-.08-.78-.19-1.15-.31s-.7-.26-1-.42-.51-.3-.65-.44c.14-.71.34-1.4.6-2.08.26-.68.56-1.28.9-1.8.34-.52.74-.95 1.18-1.27.44-.32.93-.48 1.45-.48s1.03.13 1.45.38a3.955 3.955 0 0 1 1.7 2.2c.14.45.21.85.21 1.24 0 .57-.08 1.05-.25 1.44Zm20.55-18.51h4.26v23.53h-4.26zm23.54 1.14a2 2 0 0 0-.82-.16c-.3 0-.57.05-.82.16s-.47.26-.66.45-.34.41-.45.66-.16.52-.16.82.05.57.16.82.26.47.45.66.41.34.66.45.52.16.82.16.57-.05.82-.16a2.148 2.148 0 0 0 1.11-1.11c.11-.25.16-.52.16-.82s-.05-.57-.16-.82a2.148 2.148 0 0 0-1.11-1.11Zm4.91 0a2 2 0 0 0-.82-.16c-.3 0-.57.05-.82.16s-.47.26-.66.45-.34.41-.45.66-.16.52-.16.82.05.57.16.82.26.47.45.66.41.34.66.45.52.16.82.16.57-.05.82-.16a2.148 2.148 0 0 0 1.11-1.11c.11-.25.16-.52.16-.82s-.05-.57-.16-.82a2.148 2.148 0 0 0-1.11-1.11Zm13.64 18.78h-10.53c-.34 0-.61-.03-.81-.1a.986.986 0 0 1-.48-.34c-.11-.16-.19-.37-.23-.62s-.06-.58-.06-.97v-10.58h-4.22v1.85c-.63.15-1.33.34-2.08.56s-1.51.48-2.27.79c-.76.31-1.49.67-2.19 1.09-.7.41-1.33.89-1.88 1.42s-.99 1.14-1.32 1.81-.49 1.42-.49 2.25c0 .94.19 1.74.58 2.41.39.67.89 1.22 1.5 1.65s1.29.74 2.05.94 1.5.3 2.23.3 1.43-.08 2.1-.23 1.35-.41 2.06-.79c.14.29.33.57.57.83s.55.48.93.67c.38.19.83.34 1.37.46s1.17.17 1.92.17h15.52v-23.53h-4.26v19.94Zm-16.32-1.88c-.44.28-.94.51-1.52.69s-1.18.26-1.8.26c-.34 0-.68-.04-1.02-.11s-.64-.2-.91-.38-.49-.42-.65-.71-.25-.65-.25-1.08c0-.52.14-1 .43-1.43.29-.43.7-.82 1.24-1.16.54-.34 1.19-.65 1.94-.92s1.6-.5 2.54-.7v5.55Zm110.33 1.88h-5.42a21.766 21.766 0 0 1-2.51-.17c-.4-.05-.77-.11-1.12-.18s-.65-.14-.92-.22c.75-.77 1.37-1.5 1.84-2.17.47-.67.85-1.29 1.12-1.85s.46-1.06.56-1.51.15-.83.15-1.15c0-.62-.18-1.16-.53-1.6s-.81-.81-1.37-1.09-1.18-.48-1.86-.61c-.68-.13-1.36-.2-2.02-.2-.82 0-1.6.06-2.35.18s-1.44.27-2.08.45c-.64.18-1.21.38-1.73.59s-.95.41-1.31.6c-.16.1-.33.27-.48.52s-.3.52-.43.83-.25.61-.35.93-.18.58-.22.81c.09.1.22.27.41.51s.43.56.72.97l.66.87c.25.33.53.67.84 1.02.3.35.61.7.93 1.04s.64.65.96.93c-.38.14-.93.27-1.65.38s-1.51.16-2.4.16h-7.94c-.79 0-1.54-.07-2.25-.22s-1.36-.38-1.94-.7c.09-.31.15-.62.2-.93s.07-.63.07-.95c0-.53-.06-1.09-.19-1.66s-.32-1.13-.57-1.67c-.26-.54-.58-1.05-.97-1.53s-.85-.9-1.38-1.26-1.13-.65-1.79-.86-1.4-.32-2.21-.32c-.57 0-1.2.1-1.91.3-.7.2-1.42.6-2.15 1.2-.73.59-1.44 1.44-2.13 2.54s-1.3 2.53-1.83 4.31c-.19.6-.48 1.04-.88 1.33s-.87.43-1.41.43h-29.44c-.33 0-.61-.04-.86-.12a1.24 1.24 0 0 1-.6-.43c-.16-.21-.28-.49-.36-.84-.08-.35-.12-.8-.12-1.35v-17.17h-4.26v18.07c0 .81.1 1.55.29 2.22s.5 1.24.92 1.72.96.84 1.6 1.11 1.43.39 2.35.39h30.98c1.86 0 3.26-.68 4.22-2.05.29.26.62.53.99.79.36.27.79.51 1.28.72.48.21 1.03.38 1.64.52.6.13 1.3.2 2.07.2 1.11 0 2.09-.19 2.93-.57s1.55-.89 2.13-1.52c.31.28.64.54 1.01.77s.77.43 1.23.61a7.803 7.803 0 0 0 2.16.48c.02 0 .04.01.06.02.16.03.38.04.64.04h8.22c.72 0 1.42-.05 2.1-.15s1.32-.23 1.93-.39a15.95 15.95 0 0 0 3.21-1.22c.33.16.73.35 1.22.56.48.21 1.04.4 1.66.58s1.3.33 2.04.45 1.51.18 2.33.18h10.54v-23.53h-4.26v19.94Zm-36.64-1.41c-.16.39-.4.71-.71.96-.31.25-.69.43-1.12.54a5.912 5.912 0 0 1-2.6.05c-.4-.08-.78-.19-1.15-.31s-.7-.26-1-.42-.51-.3-.65-.44c.14-.71.34-1.4.6-2.08.26-.68.56-1.28.9-1.8.34-.52.74-.95 1.18-1.27.44-.32.93-.48 1.45-.48s1.03.13 1.45.38a3.955 3.955 0 0 1 1.7 2.2c.14.45.21.85.21 1.24 0 .57-.08 1.05-.25 1.44Zm26.15-3.69c-.1.29-.27.61-.5.95s-.53.7-.89 1.08-.82.76-1.35 1.15c-.36-.27-.74-.62-1.14-1.03s-.78-.84-1.15-1.29-.71-.87-1.02-1.29-.54-.77-.7-1.06c.31-.14.63-.27.98-.39s.7-.22 1.06-.31c.35-.09.7-.15 1.03-.2s.63-.07.89-.07c.44 0 .83.05 1.2.14s.67.22.93.37.46.33.61.54.21.43.21.67c0 .2-.05.44-.16.73Zm19-14.82h4.26v23.53h-4.26z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusand);
export default __webpack_public_path__ + "static/media/musand.cd2031cf3e5b9aefa6018e33387d02da.svg";
export { ForwardRef as ReactComponent };